import FormattedMessage from "@components/UI/FormattedMessage";

const AdditionalBaggageInfoFooter = () => (
  <div className="flight-additional-info-baggage-modal-table-footer ">
    <div>
      (*) <FormattedMessage id="FlightAdditionalInfoBaggage.dimensions" />
    </div>
    <div>
      (-) <FormattedMessage id="FlightAdditionalInfoBaggage.details" />
    </div>
    <div>
      <strong>
        <FormattedMessage id="FlightAdditionalInfoBaggage.baggage" />
      </strong>{" "}
      <FormattedMessage id="FlightAdditionalInfoBaggage.baggageDescription" />{" "}
      <strong>
        <FormattedMessage id="FlightAdditionalInfoBaggage.anotherBaggage" />
      </strong>{" "}
      <FormattedMessage id="FlightAdditionalInfoBaggage.anotherBaggageDescription" />{" "}
      <strong>
        <FormattedMessage id="FlightAdditionalInfoBaggage.handBaggage" />
      </strong>{" "}
      <FormattedMessage id="FlightAdditionalInfoBaggage.handBaggageDescription" />
    </div>
  </div>
);

export default AdditionalBaggageInfoFooter;
